import { Ptag } from "components/core";
import React, { useMemo } from "react";
import { AgeGridWrapper, Divider, SumInsuredHeaderWrapper } from "./styles";
import { joinWithAndComma, newFormatRupees } from "utlis/utils";
import SumInsuredHeaderDetail from "./SumInsuredHeaderDetail";
import useUser from "hooks/useUser";
import { useNavigate } from "react-router";

function SumInsuredHeader({ sumInsured, dependents ,defaultSumInsured}) {
  const { getRole } = useUser();
  const isAdmin = getRole() === "admin";
  const navigate = useNavigate();

  const minSumInsured = useMemo(() => Math.min(...sumInsured), [sumInsured]);
  const maxSumInsured = useMemo(() => Math.max(...sumInsured), [sumInsured]);


  const sumInsuredFormatted = useMemo(() => {
    if (minSumInsured === maxSumInsured) return newFormatRupees(minSumInsured);
    return `${newFormatRupees(minSumInsured)} - ${newFormatRupees(maxSumInsured)}`;
  }, [minSumInsured, maxSumInsured]);

  const dependentsCovered = useMemo(
    () => joinWithAndComma(dependents?.covered), 
    [dependents]
  );

  const renderAgeGrid = (min, max) => (
    <>
      <AgeGridWrapper>
        <Ptag fontSize="16px" fontWeight="400" color="#4a4a4a">
          Min Age:{" "}
        </Ptag>
        <Ptag fontSize="16px" fontWeight="700" color="#4a4a4a">
          {min} years{" "}
        </Ptag>
      </AgeGridWrapper>
      <AgeGridWrapper>
        <Ptag fontSize="16px" fontWeight="400" color="#4a4a4a">
          Max Age:{" "}
        </Ptag>
        <Ptag fontSize="16px" fontWeight="700" color="#4a4a4a">
          {max} years{" "}
        </Ptag>
      </AgeGridWrapper>
    </>
  );

 

  return (
    <SumInsuredHeaderWrapper isMultiline={minSumInsured !== maxSumInsured}>
      <section>
      <SumInsuredHeaderDetail
  title="Sum Insured"
  subtitleMinMax={minSumInsured !== maxSumInsured}
  defaultSumInsured={defaultSumInsured}
  min={newFormatRupees(minSumInsured)}
  max={newFormatRupees(maxSumInsured)}
  value={sumInsuredFormatted}
/>
        {minSumInsured === maxSumInsured && dependentsCovered && dependentsCovered.trim() !== "" && <Divider />}
        {dependentsCovered && dependentsCovered.trim() !== "" && (
          <SumInsuredHeaderDetail
            title="Dependents Covered"
            value={dependentsCovered}
          />
        )}
      </section>
      {isAdmin && (
        (dependents?.children?.count ||
          (dependents?.children?.age_limit?.length > 0) ||
          (dependents?.parental?.age_limit?.length > 0)
        ) && (
        <section>
          {dependents?.children?.count && (
            <SumInsuredHeaderDetail
              title="Max no.of Children"
              value={dependents?.children?.count}
            />
          )}
          {(dependents?.children?.age_limit?.[0] ||
            dependents?.children?.age_limit?.[1]) && (
            <SumInsuredHeaderDetail title="Children Age Limit">
              {renderAgeGrid(
                dependents?.children?.age_limit?.[0],
                dependents?.children?.age_limit?.[1]
              )}
            </SumInsuredHeaderDetail>
          )}
          {(dependents?.parental?.age_limit?.[0] ||
            dependents?.parental?.age_limit?.[1]) && (
            <SumInsuredHeaderDetail title="Parental Age Limit">
              {renderAgeGrid(
                dependents?.parental?.age_limit?.[0],
                dependents?.parental?.age_limit?.[1]
              )}
            </SumInsuredHeaderDetail>
          )}
        </section>
      ))}
     
    </SumInsuredHeaderWrapper>
  );
}

export default SumInsuredHeader;
